export interface InboundWebhookProvider {
  Id: number;
  InboundWebhookSecurityTypeId: number;
  InboundWebhookProviderTypeId: number;
  Description: string;
  ProviderUrl?: string;

  IsApiKeyType(): boolean;
  IsOAuth2Type(): boolean;
  IsSvixType(): boolean;
}

export enum InboundWebhookSecurityTypeEnum {
  ApiKey = 1,
  OAuth2 = 2,
  Svix = 3,
}

export enum InboundWebhookProviderTypeEnum {
  OCR = 1,
  Manual = 2,
}

// Helper function to convert API response to domain model
export const createInboundWebhookProvider = (apiResponse: {
  Id: number;
  InboundWebhookSecurityTypeId: number;
  InboundWebhookProviderTypeId: number;
  Description: string;
  ProviderUrl?: string;
}): InboundWebhookProvider => ({
  ...apiResponse,
  IsApiKeyType: () => apiResponse.InboundWebhookSecurityTypeId === InboundWebhookSecurityTypeEnum.ApiKey,
  IsOAuth2Type: () => apiResponse.InboundWebhookSecurityTypeId === InboundWebhookSecurityTypeEnum.OAuth2,
  IsSvixType: () => apiResponse.InboundWebhookSecurityTypeId === InboundWebhookSecurityTypeEnum.Svix,
});
